import FaqView from "@/components/app/FaqView";
export default function FaqLeaseholders() {
  return <FaqView kind="leaseholders" title="FAQs for Leaseholders" accent="btn-chestnut" />;
}
